function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 470 470",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 145,
    style: {
      fill: "#FFFFFF"
    },
    width: 25,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 215,
    style: {
      fill: "#FFFFFF"
    },
    width: 25,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 285,
    style: {
      fill: "#FFFFFF"
    },
    width: 25,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 355,
    style: {
      fill: "#FFFFFF"
    },
    width: 25,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M305,367.5c0-4.143,3.358-7.5,7.5-7.5H400V15H70v440h235V367.5z M347.5,305h-155 c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h155c4.142,0,7.5,3.357,7.5,7.5S351.642,305,347.5,305z M347.5,235h-155 c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h155c4.142,0,7.5,3.357,7.5,7.5S351.642,235,347.5,235z M203.713,80H347.5 c4.142,0,7.5,3.357,7.5,7.5s-3.358,7.5-7.5,7.5H203.713c-4.142,0-7.5-3.357-7.5-7.5S199.571,80,203.713,80z M347.5,150 c4.142,0,7.5,3.357,7.5,7.5s-3.358,7.5-7.5,7.5h-155c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5H347.5z M122.197,87.196 c2.929-2.928,7.678-2.928,10.606,0l9.697,9.697l34.697-34.697c2.929-2.928,7.678-2.928,10.606,0c2.929,2.93,2.929,7.678,0,10.607 l-40,40c-1.464,1.464-3.384,2.196-5.303,2.196s-3.839-0.732-5.303-2.196l-15-15C119.268,94.874,119.268,90.126,122.197,87.196z  M170,387.5c0,4.143-3.358,7.5-7.5,7.5h-40c-4.142,0-7.5-3.357-7.5-7.5v-40c0-4.143,3.358-7.5,7.5-7.5h40 c4.142,0,7.5,3.357,7.5,7.5V387.5z M170,317.5c0,4.143-3.358,7.5-7.5,7.5h-40c-4.142,0-7.5-3.357-7.5-7.5v-40 c0-4.143,3.358-7.5,7.5-7.5h40c4.142,0,7.5,3.357,7.5,7.5V317.5z M170,247.5c0,4.143-3.358,7.5-7.5,7.5h-40 c-4.142,0-7.5-3.357-7.5-7.5v-40c0-4.143,3.358-7.5,7.5-7.5h40c4.142,0,7.5,3.357,7.5,7.5V247.5z M170,177.5 c0,4.143-3.358,7.5-7.5,7.5h-40c-4.142,0-7.5-3.357-7.5-7.5v-40c0-4.143,3.358-7.5,7.5-7.5h40c4.142,0,7.5,3.357,7.5,7.5V177.5z  M282.5,375h-90c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h90c4.142,0,7.5,3.357,7.5,7.5S286.642,375,282.5,375z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCC75"
    },
    points: "320,375 320,444.394 389.394,375  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M413.404,372.115c0.114-0.146,0.227-0.292,0.33-0.446c0.028-0.041,0.05-0.085,0.077-0.127 c0.106-0.164,0.209-0.331,0.301-0.504c0.017-0.03,0.029-0.063,0.045-0.094c0.096-0.187,0.188-0.375,0.269-0.569 c0.009-0.022,0.015-0.045,0.024-0.066c0.082-0.204,0.159-0.411,0.223-0.623c0.008-0.025,0.012-0.052,0.02-0.077 c0.061-0.208,0.116-0.418,0.159-0.632c0.012-0.061,0.017-0.122,0.028-0.183c0.031-0.181,0.063-0.36,0.081-0.545 c0.025-0.248,0.038-0.498,0.038-0.749V7.5c0-4.143-3.358-7.5-7.5-7.5h-345C58.358,0,55,3.357,55,7.5v455c0,4.143,3.358,7.5,7.5,7.5 h250c0.251,0,0.501-0.013,0.749-0.038c0.186-0.019,0.368-0.05,0.549-0.082c0.059-0.01,0.119-0.015,0.178-0.026 c0.214-0.043,0.423-0.099,0.63-0.158c0.026-0.008,0.054-0.013,0.08-0.021c0.208-0.063,0.41-0.138,0.609-0.218 c0.027-0.011,0.054-0.019,0.081-0.029c0.189-0.079,0.371-0.168,0.552-0.261c0.037-0.02,0.076-0.035,0.112-0.055 c0.165-0.088,0.323-0.187,0.48-0.287c0.05-0.031,0.102-0.059,0.151-0.092c0.146-0.098,0.285-0.205,0.423-0.313 c0.055-0.043,0.113-0.081,0.167-0.125c0.169-0.139,0.33-0.287,0.486-0.439c0.018-0.019,0.039-0.033,0.057-0.052l95-95 c0.015-0.015,0.027-0.031,0.042-0.046c0.157-0.16,0.308-0.324,0.451-0.498C413.334,372.213,413.367,372.162,413.404,372.115z  M70,15h330v345h-87.5c-4.142,0-7.5,3.357-7.5,7.5V455H70V15z M320,375h69.394L320,444.394V375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M203.713,95H347.5c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5H203.713 c-4.142,0-7.5,3.357-7.5,7.5S199.571,95,203.713,95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M137.197,112.804c1.464,1.464,3.384,2.196,5.303,2.196s3.839-0.732,5.303-2.196l40-40 c2.929-2.93,2.929-7.678,0-10.607c-2.929-2.928-7.678-2.928-10.606,0L142.5,96.894l-9.697-9.697c-2.929-2.928-7.678-2.928-10.606,0 c-2.929,2.93-2.929,7.678,0,10.607L137.197,112.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M185,157.5c0,4.143,3.358,7.5,7.5,7.5h155c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5h-155 C188.358,150,185,153.357,185,157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M162.5,130h-40c-4.142,0-7.5,3.357-7.5,7.5v40c0,4.143,3.358,7.5,7.5,7.5h40 c4.142,0,7.5-3.357,7.5-7.5v-40C170,133.357,166.642,130,162.5,130z M155,170h-25v-25h25V170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M347.5,220h-155c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5h155c4.142,0,7.5-3.357,7.5-7.5 S351.642,220,347.5,220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M162.5,200h-40c-4.142,0-7.5,3.357-7.5,7.5v40c0,4.143,3.358,7.5,7.5,7.5h40 c4.142,0,7.5-3.357,7.5-7.5v-40C170,203.357,166.642,200,162.5,200z M155,240h-25v-25h25V240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M347.5,290h-155c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5h155c4.142,0,7.5-3.357,7.5-7.5 S351.642,290,347.5,290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M162.5,270h-40c-4.142,0-7.5,3.357-7.5,7.5v40c0,4.143,3.358,7.5,7.5,7.5h40 c4.142,0,7.5-3.357,7.5-7.5v-40C170,273.357,166.642,270,162.5,270z M155,310h-25v-25h25V310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M282.5,360h-90c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5h90c4.142,0,7.5-3.357,7.5-7.5 S286.642,360,282.5,360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M162.5,340h-40c-4.142,0-7.5,3.357-7.5,7.5v40c0,4.143,3.358,7.5,7.5,7.5h40 c4.142,0,7.5-3.357,7.5-7.5v-40C170,343.357,166.642,340,162.5,340z M155,380h-25v-25h25V380z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.9ab156df88d05039125a091b87ef645a.svg";
export { ForwardRef as ReactComponent };